import { Question, SmartButton } from '@workspace/core-ts/components';
import { useGlobalForm } from '@workspace/core-ts/contexts';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { ToutMotards } from '@workspace/core-ts/icons-amo';
import { cn } from '@workspace/utils';
import { CheckIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import type { FormSchemaType } from '../schema';

export default function SelectionVehicules() {
    const methods = useSmartFormGlobal<FormSchemaType>();
    const g = useGlobalForm();
    const initialState = g.initialState as FormSchemaType;
    const Vehicules = initialState.DemandeTarif.ListeVehicules || [];
    const [selectedVehicules, setSelectedVehicules] = useState<string[]>([]); // immatriculation[]

    const handleSubmit = async (data: FormSchemaType) => {
        data.DemandeTarif.ListeVehicules = Vehicules.filter((v) => selectedVehicules.includes(v.Immatriculation as string));
        return data;
    };

    const addSelectedVehicule = (immatriculation: string) => {
        if (selectedVehicules.includes(immatriculation)) {
            setSelectedVehicules(selectedVehicules.filter((v) => v !== immatriculation));
        } else {
            setSelectedVehicules([...selectedVehicules, immatriculation]);
        }
    };

    return (
        <SmartFormGlobal {...methods} className="max-w-2xl mx-auto" onSubmit={handleSubmit}>
            <Question.Header>
                <ToutMotards />
                <Question.Title>
                    Sélectionnez les <b>véhicules</b> dont vous souhaitez <b>modifier les garanties</b> ?
                </Question.Title>
            </Question.Header>

            <div className="w-full space-y-5">
                <table className="w-full border-collapse">
                    <tbody>
                        {Vehicules.map((vehicule, vehiculeIndex) => {
                            const isSelected = selectedVehicules.includes(vehicule.Immatriculation as string);

                            return (
                                <tr className="bg-white text-center" key={vehiculeIndex}>
                                    <td className="border">
                                        <div className="py-3 px-4 text-left">
                                            <h3 className="text-base font-medium text-secondary">
                                                {vehicule.Marque} {vehicule.Modele} - {vehicule.Immatriculation}
                                            </h3>
                                            <p className="text-xs text-gray-500">Mise en circulation le {vehicule.DateMEC}</p>
                                        </div>
                                    </td>
                                    <td
                                        className={cn(
                                            'border cursor-pointer transition-all group relative align-middle px-10',
                                            isSelected ? 'bg-card text-primary hover:bg-red-100 hover:text-red-500' : 'bg-white text-gray-500 hover:bg-green-100 hover:text-green-500',
                                        )}
                                        onClick={() => addSelectedVehicule(vehicule.Immatriculation as string)}
                                    >
                                        <div className="w-full h-full flex items-center justify-center gap-2">
                                            <span className={cn('font-medium absolute text-xs', isSelected ? 'opacity-0 group-hover:opacity-100' : 'opacity-0 group-hover:opacity-0')}>
                                                Retirer de la sélection
                                            </span>
                                            <span className={cn('block text-xs font-medium absolute', isSelected ? 'opacity-0' : '')}>
                                                Ajouter <br /> à la sélection
                                            </span>
                                            <div className={cn('w-full h-full flex items-center justify-center gap-2', isSelected ? 'opacity-100 group-hover:opacity-0' : 'opacity-0 ')}>
                                                <CheckIcon aria-hidden="true" className={cn('h-5')} />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <SmartButton />
        </SmartFormGlobal>
    );
}
